<template>
  <div class="card-body px-0 pt-0 pb-3">
    <div class="table-responsive">
      <el-table border v-loading="loading" :data="filteredData" class="el-table-css" style="width: 100%">
        <el-table-column prop="dispClaimNumber" label="Claim №" width="280" />
        <el-table-column prop="accidentDateStr" label="Tarix" width="250" />
        <el-table-column prop="claimStatus" label="Status" />
        <el-table-column prop="injuredName" label="Zərərvuran" />
        <el-table-column prop="victimName" label="Zərərçəkən" />
        <el-table-column prop="policyNumber" label="Şəhadətnamə №" />
        <el-table-column width="50" fixed="right">
          <template #default="scope">
            <div class="action-buttons">
              <el-button style="padding: 0px;" type="text" title="Məlumat" size="large" @click="openDialog(scope.row)">
                <div class="square-icon">
                  <i class="fa-solid fa-info-circle" style="color: #808080; font-size: 1.2rem;"></i>
                </div>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog v-model="isDialogVisible" width="90%" top="10vh">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <titles style="margin-bottom: 0px;" text="İş məlumatı"></titles>
            <div class="d-flex align-items-center">
              <el-select v-model="selectedUserId" placeholder="Məsul şəxsi seçin" size="large" style="width: 250px;">
                <el-option v-for="user in respUsers" :key="user.id" :label="user.name" :value="user.id" />
              </el-select>
              <button type="button" class="btn bg-gradient-success ms-2" style="margin-bottom:0px"
                @click="submitSubrogation">
                <span class="btn-text">Göndər</span>
              </button>
            </div>
          </div>
          <hr style="margin:15px 0;" />
          <div class="row">
            <div class="col-md-6">
              <div style="color: #606266; font-size: 14px;">
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta müqaviləsi:</div>
                  <div class="col-8">{{ subrogationInfo.insuranceContract }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta şəhadətnaməsi №:</div>
                  <div class="col-8">{{ subrogationInfo.policyNumber }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta növü:</div>
                  <div class="col-8">{{ subrogationInfo.insuranceTypeName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Filial:</div>
                  <div class="col-8">{{ subrogationInfo.branchName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığortalı:</div>
                  <div class="col-8">{{ subrogationInfo.insuredName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta predmeti</div>
                  <div class="col-8">{{ subrogationInfo.insuredItemModel + " " + subrogationInfo.insuredItemRegNum +
                    " "
                    +
                    subrogationInfo.insuredItemYear }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Oturacaq sayı</div>
                  <div class="col-8">{{ subrogationInfo.numberOfSeats }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığortanın başlama və bitmə tarixi:</div>
                  <div class="col-8">{{ subrogationInfo.startDateStr + " - " + subrogationInfo.endDateStr }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta məbləği:</div>
                  <div class="col-8">{{ subrogationInfo.insuranceSum }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərəri müəyyən edən müəssisə:</div>
                  <div class="col-8">{{ subrogationInfo.basisPrice }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərin müəyyən edildiyi tarix:</div>
                  <div class="col-8">{{ subrogationInfo.damageDateStr }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Ümumi zərər məbləği:</div>
                  <div class="col-8">{{ subrogationInfo.damageSumLetter }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkənin zərərdə payı:</div>
                  <div class="col-8">{{ subrogationInfo.damagePercentage }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hesablanmış sığorta ödənişi:</div>
                  <div class="col-8">{{ subrogationInfo.paymentSumLetter }}</div>
                </div>
              </div>
            </div>

            <!-- Вторая колонка -->
            <div class="col-md-6">
              <div style="color: #606266; font-size: 14px;">
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisənin baş verdiyi tarix:</div>
                  <div class="col-8">{{ subrogationInfo.accidentDateStr }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Məlumat vermə tarixi:</div>
                  <div class="col-8">{{ subrogationInfo.callDateStr }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta hadisəsinin baş verdiyi ərazi:</div>
                  <div class="col-8">{{ subrogationInfo.place }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisədə zərərvuran şəxs:</div>
                  <div class="col-8">{{ subrogationInfo.injuredName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisədə zərər çəkənlərin sayı:</div>
                  <div class="col-8">{{ subrogationInfo.vehicleCount }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkən avtomobilin sürücüsü:</div>
                  <div class="col-8">{{ subrogationInfo.victimName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkən avtomobilin sürücüsünün əlaqə nömrəsi:</div>
                  <div class="col-8">{{ subrogationInfo.victimPhone }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərər vurulmuş predmetə dair məlumat:</div>
                  <div class="col-8">{{ subrogationInfo.damagedInsItemModel + " " +
                    subrogationInfo.damagedInsItemRegNum
                    + " " +
                    subrogationInfo.damagedInsItemYear }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta hadisəsinin növü:</div>
                  <div class="col-8">
                    {{ subrogationInfo.damageCategoryName }}
                    <span v-if="subrogationInfo.damageCategoryName === 'Xəsarət'">
                      - {{ item.medDamageTypeName }}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta ödənişini alan:</div>
                  <div class="col-8">{{ subrogationInfo.paymentReceivedPerson }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Telefon nömrəsi:</div>
                  <div class="col-8">{{ subrogationInfo.paymentReceivedPersonPhone }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { subrogationData, respUsers } from "@/project/Source/helper";
import Titles from "@/project/Components/Titles.vue";
import { CreateSubrogation } from "@/project/Source/subrogations";

export default {
  components: {
    Titles,
  },
  props: {
    loading: Boolean,
  },
  data() {
    return {
      data: subrogationData,
      isDialogVisible: false,
      subrogationInfo: {},
      selectedUserId: null,
      respUsers,
    };
  },
  computed: {
    filteredData() {
      return this.data || [];
    },
  },
  methods: {
    formatDateTime(dateStr) {
      if (!dateStr) return null;

      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split(".");

      const isoString = `${year}-${month}-${day}T${timePart}`;
      const date = new Date(isoString);

      if (isNaN(date)) throw new Error("Invalid date format");

      return date.toISOString().slice(0, 19);
    },

    openDialog(row) {
      this.subrogationInfo = row;
      this.isDialogVisible = true;
    },

    async submitSubrogation() {
      if (!this.selectedUserId) {
        this.$message.error("Məsul şəxsi seçin!");
        return;
      }
      const s = this.subrogationInfo;
      const payload = {
        id: s.id,
        accidentId: s.accidentId,
        claimId: s.claimId,
        subrogationAmount: s.subrogationAmount,
        insuranceContract: s.insuranceContract,
        policyNumber: s.policyNumber,
        dispClaimNumber: s.dispClaimNumber,
        insuranceTypeName: s.insuranceTypeName,
        policyType: s.policyType,
        branchName: s.branchName,
        insuredName: s.insuredName,
        insuredItemModel: s.insuredItemModel,
        insuredItemRegNum: s.insuredItemRegNum,
        insuredItemYear: s.insuredItemYear,
        numberOfSeats: s.numberOfSeats,
        startDateStr: this.formatDateTime(s.startDateStr),
        endDateStr: this.formatDateTime(s.endDateStr),
        insuranceSum: s.insuranceSum,
        accidentDateStr: this.formatDateTime(s.accidentDateStr),
        callDateStr: this.formatDateTime(s.callDateStr),
        place: s.place,
        injuredName: s.injuredName,
        vehicleCount: s.vehicleCount,
        victimName: s.victimName,
        victimPhone: s.victimPhone,
        damagedInsItemModel: s.damagedInsItemModel,
        damagedInsItemRegNum: s.damagedInsItemRegNum,
        damagedInsItemYear: s.damagedInsItemYear,
        damageCategoryName: s.damageCategoryName,
        medDamageTypeName: s.medDamageTypeName,
        basisPrice: s.basisPrice,
        damageDateStr: this.formatDateTime(s.damageDateStr),
        damageSumLetter: s.damageSumLetter,
        damagePercentage: s.damagePercentage,
        paymentSumLetter: s.paymentSumLetter,
        paymentReceivedPerson: s.paymentReceivedPerson,
        paymentReceivedPersonPhone: s.paymentReceivedPersonPhone,
        // new fields
        incidentCauseReason: s.incidentCauseReason,
        insCompanyPlace: s.insCompanyPlace,
        insCompanyContact: s.insCompanyContact,
        insCompanyEmail: s.insCompanyEmail,
        tortfeasorPlace: s.tortfeasorPlace,
        paidAmount: s.paidAmount,
        policyDate: this.formatDateTime(s.policyDate),
        companyPaymentDate: this.formatDateTime(s.companyPaymentDate),
        signatoryName: s.signatoryName,
        signatoryPosition: s.signatoryPosition,
        signerCompanyName: s.signerCompanyName,
        respUserId: this.selectedUserId,
        user: this.$store.state.user.id,
      };
      try {
        await CreateSubrogation(payload);
        this.$message.success("Uğurlu əməliyyat!");
        const ix = this.data.findIndex(x => x.id === s.id);
        if (ix !== -1) this.data.splice(ix, 1);
        this.isDialogVisible = false;
      } catch {
        this.$message.error("Xəta baş verdi!");
      }
    },

  },
};
</script>
